/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-08-15 19:46:24
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-27 21:32:26
 * @FilePath: \baishu_react_ui\src\components\BsyComboBox\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";

import "./index.css";
import BsySelectCheckBox from "../BsySelectCheckBox";
import { BsyUtils } from "../../utils/Utils";

class BsyComboCheckBox extends BsySelectCheckBox {
  constructor(props) {
    super({
      baseCls: "BsyComboCheckBox",
      type: "combocheck",
      ...props,
    });
  }

  showItem = () => {
    const { items } = this.state;
    const { valueField, textField } = this.options;
    const { value } = this;
    let text = [];

    if (!value) {
      items &&
        items.map((val) => {
          if (val.selected) {
            text.push(val[textField]);
          }
        });
      return text;
    } else {
      let ddmap = {};
      items &&
        items.map((val) => {
          ddmap[val[valueField]] = val;
        });
      if (value && Array.isArray(value)) {
        value.map((data) => {
          if (!ddmap[data]) {
            if (data === "fx_param_empty") {
              text.push(this.options.emptySelectText);
            } else text.push(data);
          } else {
            if (ddmap[data][textField]) {
              text.push(ddmap[data][textField]);
            } else {
              text.push(ddmap[data][valueField]);
            }
          }
        });
      }
    }

    return text;
  };

  selectItem = (val) => {
    this.isEditd = true;
    this.value = [...val];
    this.setState({
      value: this.value,
    });
  };

  getValue = () => {
    return this.value;
  };

  checkValidate = () => {
    var a = this.options,
      b = !0;
    this.setInvalidateTypeText("");
    a.allowBlank || (b = !BsyUtils.isObjectEmpty(this.value));
    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    return b;
  };

  findSelectItem = (val) => {
    const { items } = this.state;
    const { valueField } = this.options;
    this.selectItems = [];
    if (!val || val.length === 0) return;

    if (!items) {
      return;
    }

    this.selectItems = items.filter((e) => {
      return val.indexOf(e[valueField]) > -1;
    });
  };

  setValue = (value) => {
    this.value = value;
    this.setState({
      value: value,
      items: this.filterData(),
    });
  };

  componentWillUnmount() {
    const { subform } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.value, null, this],
        !1
      );
    }
  }

  renderDisablePane = (text) => {
    const { colorEnable } = this.options;
    const { valueField } = this.options;

    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
        ref={this.element}
      >
        {colorEnable ? (
          this.selectItems.map((e, ind) => {
            return (
              <span
                className={" bsy-text-tag middle single-line  "}
                key={"df" + ind}
                style={{
                  background: e && e.color,
                  color: "#fff",
                  border: "1px solid " + e && e.color,
                }}
              >
                {e[valueField]}
              </span>
            );
          })
        ) : (
          <>{Array.isArray(text) ? text.join(",") : text}</>
        )}
      </div>
    );
  };

  render() {
    const { minWidth, cssName, css, colorEnable, valueField, waterMark, hint } =
      this.options;
    const { showList } = this.state;
    let text = this.showItem();
    if (colorEnable) this.findSelectItem(text);

    if (!this.isEnabled()) {
      return this.renderDisablePane(text);
    }

    return (
      <div
        className={cssName + " " + (showList ? "open" : "")}
        style={{
          minWidth: minWidth,
          ...css,
        }}
        ref={this.element}
        onClick={this.autoSelectList}
      >
        <div className="showText">
          <div className="selectShowText">
            {colorEnable ? (
              this.selectItems.length ? (
                this.selectItems.map((e, ind) => {
                  return (
                    <span
                      className={" bsy-text-tag  middle multi-line  "}
                      key={"df" + ind}
                      style={{
                        background: e && e.color,
                        color: "#fff",
                        border: "1px solid " + e && e.color,
                      }}
                    >
                      {e[valueField]}
                    </span>
                  );
                })
              ) : (
                <span data-watermark={waterMark || hint}></span>
              )
            ) : (
              <span data-watermark={waterMark || hint}>
                {Array.isArray(text) ? text.join(",") : text}
              </span>
            )}
          </div>

          <div
            className={
              "iconSelect " + (!BsyUtils.isObjectEmpty(text) ? "has-value" : "")
            }
          >
            <i
              className="icon-bsy-xiala"
              style={{
                transform: showList ? "rotateX(180deg)" : "",
              }}
            >
              {" "}
            </i>
            <i
              className="widget-icon icon-dingding-guide-close"
              onClick={this.clear}
            ></i>
          </div>
        </div>
      </div>
    );
  }
}

export default BsyComboCheckBox;
